module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/3_3137bbbd85ecfeeed5e1179cc6818e82.png";